import { ExtractedSettlementCostLine } from './receiver-costs';
import { supabase } from '../supabase';

export interface SettlementDetail {
  exportadora: string;
  referencia: string;
  cliente: string;
  // Preserve the official client when creating a settlement from shipment rows.
  exporter_receiver_id?: number | null;
  nave: string;
  mercado: string;
  categoria: string;
  nro_contenedor: string;
  fecha_venta: string;
  color: string;
  embalaje_etiqueta: string;
  formato: string;
  pallet_identificador: string;
  variedad: string;
  peso_bulto: number;
  calibre_color: string;
  bultos_cargados: number;
  precio_por_caja: number;
  kilos: number;
  moneda: string;
  clausula: string;
  ingreso_moneda_origen: number;
  tax_moneda_origen: number;
  comision_moneda_origen: number;
  costos_logisticos_moneda_origen: number;
  repacking_costs_moneda_origen: number;
  flete_usd: number;
  tipo_cambio: number;
  codigo_embalaje?: string;
}

export interface ExcelProcessRequest {
  excelData: string; // base64 encoded
  filename: string;
  receiverName: string;
  exporterId: number;
  speciesId: number;
  useAI?: boolean;
  previewOnly?: boolean;
}

export interface ExcelProcessResponse {
  success: boolean;
  data?: SettlementDetail[];
  costLines?: ExtractedSettlementCostLine[];
  error?: string;
}

export const processExcelFile = async (
  request: ExcelProcessRequest
): Promise<ExcelProcessResponse> => {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw new Error('AUTH_REQUIRED');
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/excel-process`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify(request),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to process Excel file');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error processing Excel file:', error);
    throw error;
  }
};

// Helper function to convert File to base64
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result as string;
      // Remove the data URL prefix (e.g., "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,")
      const base64Data = base64String.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = (error) => reject(error);
  });
};
